import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetWorkListParamsSchema = ActionCommonParamsSchema.extend({
    cursor: z.number().optional(),
    count: z.number().optional(),
});

export type DouyinGetWorkListParams = z.infer<typeof DouyinGetWorkListParamsSchema>;
